import React, { useEffect, useState } from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { useFetchProfileData } from '../../hooks/useFetchProfileData';
import { FooterMultiStepProgress } from '../../layout/footerMultiStepProgress';
import {
  MemberInformation,
  PrescriberInformation,
  MedicationInformation,
} from './pages';
import { FORM_API_TYPE } from '../../../../types/online-forms.types';
import { emptyStorage } from '../../helpers';
import { ErrorModal } from '../../layout/errorModal';

export function MedicationForm(props: any) {
  const { closeForm, accessToken } = props;
  const [isProfileLoading, setProfileLoading] = useState(false);
  const apiResponse = useFetchProfileData(
    (val: boolean) => setProfileLoading(val),
    accessToken,
  );
  const apiData = apiResponse[0];
  const errMsg = apiResponse[1];
  const [isErrorHandling, setErrorHandling] = useState<boolean>(false);
  const [isValidateForm, setIsValidateForm] = useState<boolean>(false);
  useEffect(() => {
    emptyStorage();
  }, []);

  const componentList = [
    <MemberInformation
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
      profileResponseData={apiData}
    />,
    <PrescriberInformation
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
    />,
    <MedicationInformation
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
    />,
  ];

  return (
    <StackLayout
      horizontalAlignment="center"
      data-testid="medication-form"
      css={{ position: 'relative', minHeight: '100vh' }}
    >
      {apiData && (
        <FooterMultiStepProgress
          list={componentList}
          handleFormOrNext={isErrorHandling}
          isValidateForm={(val: boolean) => setIsValidateForm(val)}
          closeForm={closeForm}
          formName={FORM_API_TYPE.MEDICATION_EXCEPTION}
        />
      )}
      {errMsg && <ErrorModal onClose={closeForm} />}
      {isProfileLoading && <LoadingIndicator />}
    </StackLayout>
  );
}
